export const MENU_ITEMS = [
	{ name: 'Inicio', icon: 'home', path: '/home' },
	{
		name: 'Mi negocio',
		icon: 'drivers-license',
		path: '/information',
	},
	{ name: 'Pedidos', icon: 'server', path: '/orders' },
	{
		name: 'Productos',
		icon: 'cubes',
		path: '/products',
	},
	{ name: 'Reporte', icon: 'pie-chart', path: '/reports' },
	{ name: 'Facturación y pagos', icon: 'file-excel', path: '/payments' },
	// { name: 'Ads', icon: 'bullhorn', path: '/ads' },
	{ name: 'Soporte', icon: 'question-circle', path: '/support' },
]

export const PARTNER_ITEMS = [
	{ name: 'Inicio', icon: 'home', path: '/home' },
	{
		name: 'Cuenta',
		icon: 'drivers-license',
		path: '/account',
	},
	{ name: 'Pedidos', icon: 'server', path: '/orders' },
	{
		name: 'Negocios',
		icon: 'shopping-bag',
		path: '/companies',
	},
	{
		name: 'Pagos a negocios',
		icon: 'file-excel',
		path: '/companies-payments',
	},
	{
		name: 'Operadores',
		icon: 'operator',
		path: '/riders',
	},
	{
		name: 'Pagos de operadores',
		icon: 'file-excel',
		path: '/riders-payments',
	},
	{ name: 'Reporte', icon: 'pie-chart', path: '/reports' },
	{ name: 'Zonas', icon: 'map', path: '/zones' },
	// { name: 'Facturación y pagos', icon: 'file-excel', path: '/payments' },
	{ name: 'Gastos', icon: 'expense', path: '/expenses' },
	// { name: 'Bases', icon: 'amount', path: '/bases' },
	// { name: 'Ads', icon: 'bullhorn', path: '/ads' },
	{ name: 'Whatsapp', icon: 'message', path: '/whatsapp' },
	// { name: 'Solicitudes', icon: 'envelope', path: '/requests' },
	{ name: 'Soporte', icon: 'question-circle', path: '/support' },
]

export const DELIVERY_ITEMS = [
	{
		name: 'Pedidos',
		icon: 'server',
		path: '/',
	},
	{
		name: 'Cuenta',
		icon: 'drivers-license',
		path: '/account',
	},
	{
		name: 'Operadores',
		icon: 'operator',
		path: '/riders',
	},
]
